import axios from 'axios';

const axiosInstance = axios.create({
    // baseURL: "http://localhost:5000/",
    baseURL: "https://social-hub-backend.vercel.app/",
})

export default axiosInstance;